import { render, staticRenderFns } from "./DataSharesList.vue?vue&type=template&id=e326577c&scoped=true"
import script from "./DataSharesList.vue?vue&type=script&lang=js"
export * from "./DataSharesList.vue?vue&type=script&lang=js"
import style0 from "./DataSharesList.vue?vue&type=style&index=0&id=e326577c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e326577c",
  null
  
)

export default component.exports